/* In-session search relevance: only the current query, no storage or network requests. */
(() => {
 'use strict';
 const norm=s=>String(s||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/[_-]/g,' ').replace(/\s+/g,' ').trim();
 const isRoutine=q=>/\b(routine|regimen|regime|rituel|complete|complet|build me|creer moi|cree moi|night|bedtime|soir|morning|matin|three.step|3.step)\b/.test(norm(q));
 const stop=new Set(['the','and','for','with','want','need','help','show','best','pour','les','des','une','mon','mes','sur','avec','sans','that','please','your','you','my','product','produit']);
 function words(q){return [...new Set(norm(q).split(/[^a-z0-9]+/).filter(x=>x.length>2&&!stop.has(x)))].slice(0,10);}
 function score(query,title,type,tags){
   const w=words(query),t=norm(title),kind=norm(type),tax=norm(tags),exact=norm(query);
   let v=0;
   for(const term of w){
     const boundary=new RegExp('(^|[^a-z0-9])'+term+'([^a-z0-9]|$)');
     if(boundary.test(t))v+=10;else if(t.includes(term))v+=4;
     if(boundary.test(kind))v+=16;else if(kind.includes(term))v+=6;
     if(boundary.test(tax))v+=14;else if(tax.includes(term))v+=5;
   }
   if(exact.length>3&&t.includes(exact))v+=25;
   return v;
 }
 function rankPredictive(root,query){
   const list=root.querySelector('#predictive-search-results-products-list');
   if(!list)return;
   const choices=[...list.children].filter(x=>x.matches('.predictive-search__list-item'));
   const sorted=choices.map((el,i)=>({el,i,v:score(query,el.dataset.canviaTitle,el.dataset.canviaType,el.dataset.canviaTags)}));
   sorted.sort((a,b)=>b.v-a.v||a.i-b.i);
   sorted.forEach(x=>list.appendChild(x.el));
   list.querySelectorAll('.canvia-best-one').forEach(el=>el.remove());
   if(sorted.length){
     const badge=document.createElement('span');
     badge.className='canvia-best-one';badge.textContent=list.dataset.canviaBestLabel||'Best match';
     sorted[0].el.querySelector('.predictive-search__item-heading')?.prepend(badge);
   }
 }
 function rankSearch(){
   const full=document.querySelector('[data-canvia-all-search-results]');
   const section=document.querySelector('[data-canvia-best-section]');
   const best=section?.querySelector('[data-canvia-best-grid]');
   if(!full||!best||!section||section.dataset.canviaBestReady)return;
   section.dataset.canviaBestReady='true';
   const query=full.dataset.canviaQuery||new URLSearchParams(location.search).get('q')||'';
   if(isRoutine(query))return;
   const eligible=[...full.children].filter(x=>x.querySelector('.canvia-v2-product-card'));
   if(!eligible.length)return;
   eligible.map((el,i)=>{const p=el.querySelector('[data-canvia-product-handle]');return {el,i,v:score(query,p?.dataset.canviaTitle,p?.dataset.canviaType,p?.dataset.canviaTags)};})
     .sort((a,b)=>b.v-a.v||a.i-b.i).slice(0,4)
     .forEach((x,i)=>{
       best.appendChild(x.el);
       if(i===0){
         x.el.classList.add('canvia-search-top-match');
         const badge=document.createElement('span');
         badge.className='canvia-best-one';
         badge.textContent=best.dataset.canviaBestLabel||'Best match';
         x.el.querySelector('.canvia-v2-product-card__content h3')?.before(badge);
       }
     });
   section.hidden=false;
 }
 function setupRoutine(q){
   const panel=document.querySelector('[data-canvia-routine-intent]');
   if(!panel||!isRoutine(q))return;
   panel.hidden=false;
   const hair=/\b(hair|cheveu|cheveux|scalp|shampoo)\b/.test(norm(q));
   const skinList=panel.querySelector('[data-canvia-skin-steps]'),hairList=panel.querySelector('[data-canvia-hair-steps]');
   if(skinList)skinList.hidden=hair;
   if(hairList)hairList.hidden=!hair;
   const nodes=[...(hair?hairList:skinList)?.querySelectorAll('[data-canvia-step-handle]')||[]];
   const handles=nodes.map(el=>el.dataset.canviaStepHandle);
   const valid=handles.length===3&&new Set(handles).size===3;
   const start=panel.querySelector('[data-canvia-build-routine]');
   if(start)start.hidden=!valid;
   const missing=panel.querySelector('[data-canvia-routine-incomplete]');
   if(missing)missing.hidden=valid;
   if(valid && start)start.addEventListener('click',()=>{
     document.dispatchEvent(new CustomEvent('canvia:build-three-step-routine',{detail:{handles}}));
   },{once:true});
 }
 function setupHints(){
   document.querySelectorAll('.canvia-discovery__form input[name="q"]').forEach(input=>{
     const hint=input.closest('.canvia-discovery__search')?.querySelector('[data-canvia-routine-hint]');
     if(!hint)return;
     const update=()=>{hint.hidden=!isRoutine(input.value);};
     input.addEventListener('input',update);update();
   });
 }
 function init(){rankSearch();setupRoutine(new URLSearchParams(location.search).get('q')||'');setupHints();}
 window.CanviaBestMatches={isRoutine,rankPredictive,score};
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
 document.addEventListener('shopify:section:load',init);
})();
